





















import { useVModel } from '@vueuse/core';
import { computed, defineComponent, PropType, ref } from '@vue/composition-api';

import { IHSCode } from '@/models';

import { VAutocomplete } from 'vuetify/lib/components';
import { useFetchHSCodes } from '@/composable/hs-codes';

export default defineComponent({
  name: 'HSCodeAutoCompletePicker',

  props: {
    value: [Array, String, Object] as PropType<
      IHSCode | string | (IHSCode | number)[]
    >,

    errorMessages: {
      type: [String, Array] as PropType<string | string[]>
    },

    itemText: {
      type: String,
      default: 'code'
    }
  },

  setup(props, { emit }) {
    const hsCodeVModel = useVModel(props, 'value', emit, { passive: true });

    const errorMessageList = computed(() => {
      let errorList: string[] = [];

      if (error.value) {
        errorList.push(error.value.message);
      }
      if (props.errorMessages) {
        if (Array.isArray(props.errorMessages)) {
          errorList.push(...props.errorMessages);
        } else {
          errorList.push(props.errorMessages);
        }
      }

      return errorList;
    });

    const { error, hsCodes, isLoading } = useFetchHSCodes();

    // /** @public */
    const autocompleteRef = ref<
      InstanceType<typeof VAutocomplete> & { reset: () => void }
    >();

    /** @public */
    function reset() {
      if (autocompleteRef.value) autocompleteRef.value.reset();
    }

    return {
      reset,
      autocompleteRef,
      hsCodes,
      hsCodeVModel,
      isLoading,
      errorMessageList
    };
  }
});
